import { render } from "./search-bar.vue?vue&type=template&id=5957463d&lang=pug"
import script from "./search-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./search-bar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__